import { render, staticRenderFns } from "./BusinessSegmentTable.vue?vue&type=template&id=e5d7b0d8&"
import script from "./BusinessSegmentTable.vue?vue&type=script&lang=js&"
export * from "./BusinessSegmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports